import { ListItemIcon, ListItemText, MenuItem, MenuList } from '@mui/material'
import { ReactNode } from 'react'

export type MenuState = {
  anchorEl: HTMLElement | null
  id?: number
}

type Option = {
  label: string
  subtitle?: string
  disabled?: boolean
  onClick: () => void
  icon?: ReactNode
}

type Props = {
  options: Option[]
}

export default function MenuOptions({ options }: Props) {
  return <MenuList>
    {
      options.map((option, index) => <MenuItem key={index} onClick={option.onClick} disabled={option.disabled}>
        {
          option.icon ?
            <ListItemIcon>
              {option.icon}
            </ListItemIcon>
            :
            null
        }
        <ListItemText secondary={option.subtitle} secondaryTypographyProps={{ fontSize: 12, color: '#ccc' }}>
          {option.label}
        </ListItemText>
      </MenuItem>)
    }
  </MenuList>
}
